import {IRule, IBlock, PropsQueryGroup, IMapData} from "../../helpers/Interfaces"
import OneRule from "./OneRule";
import Button from "../../components/Button"
import {useContext, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";

interface HomeProps extends PropsQueryGroup {
    currentGroup: IBlock;
    level: number;
    currentRules: any[];
    index: number;
    mapData: IMapData;
    dragElem: any;
    // setDragID: any;
}

export default function QueryGroup(props: HomeProps) {

    let {userPermissions} = useContext(AuthContext)

    const {condObject, setCondObject, currentGroup, level, currentRules, index, mapData, dragElem} = props
    // console.log('INITIAL object: ', condObject)

    function handleChange(value: string, name: string) {
        currentGroup.condition = value
        setCondObject(JSON.parse(JSON.stringify(condObject)))
    }

    let emptyRule: IRule = {
        ID: 0,
        fieldType: '',
        fieldName: '',
        fieldID: '',
        valueCondition: 'equal (=)',
        values: '[]',
        useAS: '',
        returnTemplate: '',
        transformRules: ''
    }

    function addRule() {
        let newRule = JSON.parse(JSON.stringify(emptyRule))
        newRule.ID = ++condObject.ID
        // newRule.ID = condObject.ID + 1
        // condObject.ID = newRule.ID

        // newRule.ID = ++condObject.ID

        currentGroup.rules.push(newRule)
        setCondObject(JSON.parse(JSON.stringify(condObject)))
    }

    function addGroup() {
        // console.log('Add Group MaxID', condObject.ID)
        // let newRule = JSON.parse(JSON.stringify(emptyRule))
        let newGroup = {
            ID: 0,
            condition: 'and',
            rules: []
        }
        newGroup.ID = ++condObject.ID
        // newGroup.ID = condObject.ID + 1
        // condObject.ID = newGroup.ID

        currentGroup.rules.push(newGroup)
        setCondObject(JSON.parse(JSON.stringify(condObject)))
    }

    function delGroup() {
        currentRules.splice(index, 1)
        setCondObject(JSON.parse(JSON.stringify(condObject)))
    }


    // !!!! DRAG-n_DROP


    // const dragItem: any = useRef()
    const dragNode: any = useRef()
    // const [dragItem, setDragItem] = useState(null)
    // const dragItem:any = useMemo(null, [])


    const [onEnterStyle, setOnEnterStyle] = useState<any>(null)

    const [dragging, setDragging] = useState(false)
    // START


    // useEffect(() => {
    //     // if (ref.current) {
    //     //     ref.current.addEventListener("click", () => console.log('Clicked only once'), {once: true});
    //     // }
    // }, []);


    function dragStartHandler(e: any, elem: any) {
        // e.stopPropagation()    // to avoid 'firing' multiple objects in nested elements
        // console.log('Started dragging...', elem)
        // console.log('Start dragging ...', elem)
        e.stopPropagation()
        dragElem.current = elem

        // console.log('Dragging..', elem)
        // dragItem.current = elem
        // setDragID(elem.ID)
        // console.log('Starting drag...', elem)
        // console.log(e.target)

        // e.target.style.backgroundColor = '#595959'
        // dragItem.current = elem
        // e.target.parentElement.draggable = false
        // dragNode.current = e.target
        // dragNode.current.addEventListener('dragend', dragEndHandler)
        // setDragging(true)
        // e.target.style.backgroundColor = 'gray'
    }

    function dragEndHandler(e: any) {
        // console.log('Ending drag...')
        e.target.style.backgroundColor = '#F0F0F0'
        setDragging(false)

        // dragNode.current.removeEventListener('dragend', dragEndHandler)
        // dragElem.current = undefined
        // dragNode.current = null
    }

    function dragEnterHandler(e: any) {
        // console.log('Entering drag...', dragItem.current)
        // console.log('style: ', e.target.style)
        // setOnEnterStyle(e.target.style)
        // e.target.style.backgroundColor = 'orange'
        // setDragging(false)
        // dragNode.current.removeEventListener('dragend', dragEndHandler)
        // dragItem.current = null
        // dragNode.current = null
    }

    function dragLeaveHandler(e: any) {
        // console.log('Leaving drag...', dragItem.current)
        // if (e.target.className === 'rule-container') {
        //     e.target.style.backgroundColor = 'orange'
        // }
        //
        // // setDragging(false)
        // // dragNode.current.removeEventListener('dragend', dragEndHandler)
        // // dragItem.current = null
        // // dragNode.current = null
    }

    function dragOverHandler(e: any) {
        // this handler is needed to fetch the 'drop' object
        e.preventDefault()
        // console.log('in over..', dragItem.current)

        // if (e.target.className === 'rule-container') {
        //     e.target.style.backgroundColor= 'orange'
        // }

        // console.log(e.target.className)

    }


    function loopList(rules: any, dragElem: any, dropID: any, drag: boolean) {
        // console.log(rules, dragElem, dropID, drag)
        for (let i = 0; i < rules.length; i++) {

            let item = rules[i]

            if (item.ID === dragElem.ID && drag) {
                rules.splice(i, 1)
                // console.log('Match drag!', dragElem.ID)
                return
            } else if (item.ID === dropID && !drag) {
                rules.splice(i, 0, dragElem)
                return
                // console.log('Match drop!', dropID)
            }
            // console.log(item)
            if ('rules' in item) {
                loopList(item.rules, dragElem, dropID, drag)
            }
        }
    }

    function dropHandler(e: any, elem: any) {
        e.preventDefault()
        e.stopPropagation()
        // console.log('drop object:', elem)
        let dropItem = elem
        // console.log(elem)

        let outObj = JSON.parse(JSON.stringify(condObject))
        if (dragElem.current.ID !== dropItem.ID) {
            loopList(outObj.rules, dragElem.current, dropItem.ID, true)
            loopList(outObj.rules, dragElem.current, dropItem.ID, false)
            // console.log('Out obj AFTER:', outObj)
            setCondObject(outObj)
        }
        dragElem.current = undefined
    }


    return (

        <div className="inner-group-container">
            {/*/!*{level}*!/ !! could be used to change backgroundColor of Inner Groups !! */}

            <div className="group-container-actions">
                {/*{level}*/}
                {/*Condition Selector*/}
                <select
                    id="condition"
                    name="condition"
                    value={currentGroup.condition}
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    disabled={!userPermissions.canEdit}
                >
                    <option value="and">AND</option>
                    <option value="or">OR</option>
                </select>

                {/*<button type="button" className="btn btn-add-rule" onClick={addRule}>+ Rule</button>*/}
                {/*<button type="button" className="btn btn-add-rule" onClick={addGroup}>+ Group</button>*/}
                {/*{currentGroup !== condObject &&*/}
                {/*    <button type="button" className="btn btn-del-rule" onClick={delGroup}>- Group</button>}*/}

                <Button type={userPermissions.canEdit ? "primary" : "secondary"} text="+ Rule" onclick={userPermissions.canEdit ? addRule : undefined}/>
                <Button type={userPermissions.canEdit ? "primary" : "secondary"} text="+ Group" onclick={userPermissions.canEdit ? addGroup : undefined}/>
                {currentGroup !== condObject && (
                    <><Button type="delete" text="- Group" onclick={delGroup}/>
                        <div><small>|||</small></div>
                    </>)
                }


            </div>

            {
                currentGroup.rules.map((elem: (IRule | IBlock | any), indx) => {

                    return (
                        // <div key={indx} style={{borderLeft: "1px solid grey"}}> Draws left bars
                        <div key={indx}

                             onDragStart={(e) => dragStartHandler(e, elem)}
                            // console.log(setDragID)
                            // //
                            // onDragEnter={(e) => dragEnterHandler(e)}
                            // onDragLeave={(e) => dragLeaveHandler(e)}
                            //
                            //  onDragEnd={(e) => dragEndHandler(e)}
                            // //
                             onDragOver={(e) => dragOverHandler(e)}
                             onDrop={(e) => dropHandler(e, elem)}

                             style={{cursor: 'grab'}}
                             draggable={true}

                        >

                            {elem.condition &&
                                <QueryGroup
                                    condObject={condObject}
                                    setCondObject={setCondObject}
                                    currentGroup={elem}
                                    level={level + 1}
                                    currentRules={currentGroup.rules}
                                    index={indx}
                                    mapData={mapData}
                                    dragElem={dragElem}
                                />}

                            {!elem.condition &&
                                <OneRule
                                    condObject={condObject}
                                    setCondObject={setCondObject}
                                    rule={elem}
                                    level={level}
                                    currentRules={currentGroup.rules}
                                    index={indx}
                                    mapData={mapData}
                                />}
                        </div>
                        // </div>

                    );
                })
            }
        </div>

    )

}